import useApi from 'hooks/useApi';
import { useSelector } from 'react-redux';

const useClient = () => {
  const { cusNavId } = useSelector((state) => state.auth);
  const { customAreaApi } = useApi();

  const [{ loading: getAllClientsLoading }, fetchAllClients] = customAreaApi(
    {
      url: `${window.API_V1}/cli/clients/${cusNavId}/search/all`,
      method: 'POST',
    },
    { manual: true }
  );

  const [{ loading: getAllContactsLoading }, fetchAllContacts] = customAreaApi(
    {
      url: `${window.API_V1}/cli/contacts/${cusNavId}/search/all`,
      method: 'POST',
    },
    { manual: true }
  );

  const getAllClients = async ({ filters = [], limit = 0, skip = 0 }) => {
    const {
      data: { errors, data },
    } = await fetchAllClients({
      data: { filters, reduce: { limit, skip } },
    });
    if (errors.length) {
      throw new Error('error throw by getAllClients method in useClient hook');
    }
    return data;
  };

  const getAllContacts = async ({ filters = [], limit = 0, skip = 0 }) => {
    const {
      data: { errors, data },
    } = await fetchAllContacts({
      data: { filters, reduce: { limit, skip } },
    });
    if (errors.length) {
      throw new Error('error throw by getAllContacs method in useClient hook');
    }
    return data;
  };

  return {
    getAllClientsLoading,
    getAllClients,
    getAllContactsLoading,
    getAllContacts,
  };
};

export default useClient;
